import { useEffect, useState } from "react";
import { getAvailableColumns } from "@/api/columns";
import type { AvailableColumn } from "@/api/types";

/** The project's company columns — what the column selector shows and the
 *  "+ Add filter" picker offers — without the ones this user may not see
 *  (score, tags), so no list built on them filters on what it hides. */
export function useCompanyColumns(
  slug: string | null,
  { canViewScore, canViewTags }: { canViewScore: boolean; canViewTags: boolean },
): AvailableColumn[] {
  const [availableColumns, setAvailableColumns] = useState<AvailableColumn[]>([]);
  useEffect(() => {
    if (!slug) {
      setAvailableColumns([]);
      return;
    }
    let cancelled = false;
    getAvailableColumns(slug)
      .then((cols) => {
        if (cancelled) return;
        setAvailableColumns(
          cols.filter((c) => {
            if (c.key === "score" || c.key === "effective_score") return canViewScore;
            if (c.key === "tags") return canViewTags;
            return true;
          }),
        );
      })
      .catch((err) => {
        if (cancelled) return;
        console.warn("[Companies] getAvailableColumns failed:", err);
        setAvailableColumns([]);
      });
    return () => {
      cancelled = true;
    };
  }, [slug, canViewScore, canViewTags]);
  return availableColumns;
}
